import styled from "@emotion/styled";
import { Button, Theme, Typography, useTheme } from "@mui/material";

type ScrollNavTabProps = {
  // Props, if any
  title: string;
  variant: any;
  isActive: boolean;
  backgroundcolor?: string;
  handleClick: () => void;
};

const ScrollNavTab = ({
  title,
  variant,
  isActive,
  backgroundcolor,
  handleClick,
}: ScrollNavTabProps) => {
  const theme = useTheme();
  //const [isActive, setIsActive] = useState<boolean>(false);

  const handleClickLocal = () => {
    handleClick();
  };

  return (
    <StyledTabButton
      className={isActive ? "active" : ""}
      theme={theme}
      onClick={handleClickLocal}
      backgroundcolor={backgroundcolor}
    >
      <Typography variant={variant} lineHeight={0.85}>
        {title}
      </Typography>
    </StyledTabButton>
  );
};

export default ScrollNavTab;

interface StyledTabButtonProps {
  theme: Theme;
  backgroundcolor?: string;
}

const StyledTabButton = styled(Button)`
  background-color: transparent;
  width: fit-content;
  padding: 0;
  border: none;
  cursor: pointer;
  justify-content: start;
  font-size: 1rem;
  padding: 0.5rem 1rem;
  margin-left: -1rem;
  transition: all 0.3s ease;
  &:hover {
    background-color: rgba(0, 0, 0, 0.1);
  }
  &:focus {
    outline: none;
  }
  &.active {
    ${({ theme, backgroundcolor }: StyledTabButtonProps) => `
        background: ${
          backgroundcolor ? backgroundcolor : theme.palette.gradients.greenBlue
        }; 
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
      
    `}
  }

  &:first-of-type {
    .MuiTypography-root {
      text-transform: capitalize;
    }
  }
`;
